export class DialogModel {
    constructor(
      public topic: string,
      public medicineList: Array<any>,
      public key: any,
      public dialogType: string
    ) {}
  }
  